import { Directive, HostBinding, Input } from '@angular/core';
import { UserStatusInfoRemoteDto } from '../../../../generated/signalR/user-status-info-remote-dto';
import { UserStatusEnum } from '../../../samwebDescription/samwin/UserStatusEnum';
import { StatusType } from '../../../../generated/signalR/status-type';
import _ from 'lodash';

/**
 * Adds the following classes to the hosted component:
 *   - user-status-ready
 *   - user-status-not-ready
 *   - user-status-logged-off
 *   - user-status-busy
 */
@Directive({
   selector: '[samwebUserStatusClass]',
})
export class UserStatusClassDirective {
   @Input('samwebUserStatusClass')
   public userStatusInfo: UserStatusInfoRemoteDto;

   @HostBinding('class.user-status-ready')
   get isUserStatusReady(): boolean {
      if (_.isNil(this.userStatusInfo)) {
         return false;
      }
      return this.userStatusInfo.id !== UserStatusEnum.BUSY.value && this.userStatusInfo.type === StatusType.LOGGED_ON_READY;
   }

   @HostBinding('class.user-status-not-ready')
   get isUserStatusNotReady(): boolean {
      if (_.isNil(this.userStatusInfo)) {
         return false;
      }
      return this.userStatusInfo.id !== UserStatusEnum.BUSY.value && this.userStatusInfo.type === StatusType.LOGGED_ON_NOT_READY;
   }

   @HostBinding('class.user-status-logged-off')
   get isUserStatusLoggedOff(): boolean {
      if (_.isNil(this.userStatusInfo)) {
         return false;
      }
      return this.userStatusInfo.id !== UserStatusEnum.BUSY.value && this.userStatusInfo.type === StatusType.LOGGED_OFF;
   }

   @HostBinding('class.user-status-busy')
   get isUserStatusBusy(): boolean {
      if (_.isNil(this.userStatusInfo)) {
         return false;
      }
      return this.userStatusInfo.id === UserStatusEnum.BUSY.value;
   }
}
